import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';

import {IonicModule} from '@ionic/angular';

import {PatternDetailsPage} from './pattern-details.page';
import {BaseModule} from '../../modules/base/base.module';
import {DecorationModule} from '../../modules/decoration/decoration.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        BaseModule,
        DecorationModule
    ],
    declarations: [PatternDetailsPage]
})
export class PatternDetailsPageModule {
}
